export function sessionDetailToPlaygroundSession(detail, fallbackSessionId = null) {
  if (!detail) return null;
  const sessionId = detail.id || detail.session_id || fallbackSessionId;
  if (!sessionId) return null;
  const ts = new Date(detail.started_at || detail.dispatched_at || 0).getTime();
  return {
    sessionId,
    tasks: detail.prompt ? [{
      prompt: detail.prompt,
      ts,
      sessionId,
      skillSlug: detail.context?.skill_slug || null,
    }] : [],
    latestTs: ts,
    status: detail.status,
    // Carry session_type through — widget_main sessions are hidden from the
    // session list, so they ONLY load via this detail path; WidgetChatCover
    // gates its cover hero on session_type === 'widget_main'. Dropping it here
    // made the studio "Chat with widget" FAB land on a plain chat (no cover).
    session_type: detail.session_type || null,
    title: detail.title,
    metadata: detail.metadata || null,
    result_html: detail.result_html || '',
    result_summary: detail.result_summary || '',
    context: detail.context || null,
    result: detail.result || null,
    timeline: detail.timeline || [],
    artifacts: detail.artifacts || [],
  };
}
